<template>
  <div>
    <b-row
      class="justify-content-center"
      style="width: 100%; height: 100; overflow: hidden;"
    >
      <div class="col-md-12">
        <a href="/"
          ><img
            :src="logo"
            style="width: 135px; float: left; padding: 8px;"
          />
        </a>
      </div>
    </b-row>

    <div class="app flex-row align-items-center"
      v-bind:style="{ 'background-image': 'url(' + bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'}">
    <!--
    style="
        min-height: 92vh;
        background-image: url(http://i2oc.com/design/img/ban1.jpg) !important;
        background-repeat: repeat-x !important;
      "-->
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6" sm="8">
            <b-card no-body class="mx-4">
              <b-card-body class="p-4">
                <div class="row">
                  <div
                    class="col-md-12 alert alert-success"
                    role="alert"
                    v-if="hasErrors.message"
                    data-dismiss="alert"
                  >
                    <strong
                      ><small>{{ errorMessage.message }}</small></strong
                    >
                  </div>
                </div>
                <h1>Register</h1>
                <p class="text-muted">
                  Please Enter your company details below:
                </p>
                <small class="help-block" v-if="hasErrors.username"
                  ><strong style="color: red;">{{
                    errorMessage.username
                  }}</strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.username }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="username"
                    v-model="registerData.username"
                    name="username"
                    placeholder="Name"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <small class="help-block" v-if="hasErrors.companyname"
                  ><strong style="color: red;">{{
                    errorMessage.companyname
                  }}</strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.companyname }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-building"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="companyname"
                    placeholder="Company Name"
                    v-model="registerData.companyname"
                    name="companyname"
                    required
                    autocomplete="off"
                  />
                </b-input-group>
                
                <small class="help-block" v-if="hasErrors.email"
                  ><strong style="color: red;"
                    >{{ errorMessage.email }}
                  </strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.email }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    v-model="registerData.email"
                    name="email"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <small class="help-block" v-if="hasErrors.phone"
                  ><strong style="color: red;"
                    >{{ errorMessage.phone }}
                  </strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.phone }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-phone"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    placeholder="Phone"
                    v-model="registerData.phone"
                    name="phone"
                    required
                    autocomplete="off"
                  />
                </b-input-group>
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.plan }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-tasks"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="select_plan"
                    v-model="registerData.plan"
                    name="plan"
                    disabled
                    placeholder="Select Plan"
                    required
                    autocomplete="off"
                  />
                  <button
                    type="button"
                    style="border-radius: unset;"
                    class="btn btn-pill btn-primary"
                    @click.prevent="showplan()"
                  >
                    Change Plan
                  </button>
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i style="padding: 2px;" class="fa fa-map-marker"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>

                  <model-list-select
                    :list="cityopt"
                    class="form-control"
                    style="
                      width: 20% !important;
                      -webkit-text-fill-color: rgba(
                        12,
                        11,
                        11,
                        0.87
                      ) !important;
                      height: 20px !important;
                      border: 1px solid #c2cfd6;
                      border-radius: 0px;
                    "
                    option-value="shortname"
                    option-text="dbname"
                    v-model="city"
                    placeholder="Select Registration  City"
                    @searchchange="city1"
                  >
                  </model-list-select>

                  <span style="margin-right: -17px; color: #20a8d8;"
                    >&nbsp;<i
                      v-b-tooltip.hover
                      title="This is your data centre location where your details will be saved.
              If you do not found your current city kindly choose the nearest city
              to your business location."
                      class="fa fa-info-circle"
                      style="font-size: 15px; margin-top: 10px;"
                    ></i
                  ></span>
                </b-input-group>

                <small class="help-block" v-if="hasErrors.password"
                  ><strong style="color: red;">{{
                    messagepassword
                  }}</strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.password }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-lock"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                    v-model="registerData.password"
                    name="password"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-lock"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="password"
                    class="form-control"
                    id="confirmpassword"
                    placeholder="Confirm password"
                    v-model="registerData.confirmpassword"
                    name="confirmpassword"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <small class="help-block" v-if="hasErrors.agree"
                  ><strong style="color: red;"
                    >{{ errorMessage.agree }}
                  </strong></small
                >
                <b-input-group class="mb-3">
                  <input
                    type="checkbox"
                    name="agree"
                    v-model="registerData.agree"
                    style="margin-top: 6px;"
                    autocomplete="off"
                  />&nbsp;&nbsp; I agree to the&nbsp;<a
                    href="#"
                    @click="termModal = true"
                  >
                    Terms of Service </a
                  >&nbsp;and&nbsp;
                  <a href="#" @click="privacyModal = true"> Privacy Policy </a>.
                </b-input-group>

                <b-button
                  type="button"
                  variant="primary"
                  @click.prevent="registerPost()"
                  >Create Account</b-button
                >
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-modal
          title="Privacy Policy"
          size="lg"
          v-model="privacyModal"
          @ok="privacyModal = false"
        >
          <span id="docs-internal-guid-f01e961b-0b21-5c32-3be4-2452cbe5bc18">
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >You should carefully read the following Terms and Conditions
                (also referred to as the "Terms of Use", "Terms of Service" or
                "TOS"). Your use of our service(s) implies that you have read
                and accepted these Terms and Conditions. The Website (all I2OC
                websites may hereafter be referred to, both individually and
                collectively, as "The Website") from which you accessed this
                agreement is provided to you subject to the conditions listed
                below. These terms are in addition to any other terms that
                individual Website owners within the I2OC may include for
                governing access to their Websites.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Any Non-Human Visitors to these Websites shall be considered
                agents of the individual(s) who controls, authors or otherwise
                makes use of them. Such individual(s) shall be deemed
                responsible for the actions of their Non-Human Visitor devices
                in the same manner as if they personally visited the
                Website.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >The access rights granted to you under the Terms Of Use are
                non-transferable without the express written permission of the
                owner of I2OC. You are responsible for the actions of any other
                person who may utilize your access rights on the I2OC
                Website.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: Arial;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Introduction</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >The following terms and conditions govern all use of the I2OC
                Website(s) and all content, services and products available at
                or through the Website. The Website is offered subject to your
                acceptance without modification of all of the terms and
                conditions contained herein and all other associated operating
                rules and policies (including, without limitation, I2OC Privacy
                Policy).</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Please read this Agreement carefully before accessing or using
                the I2OC Website. By accessing or using any part of the Website,
                you agree to become bound by the terms and conditions of this
                agreement. If you do not agree to all the terms and conditions
                of this agreement, then you may not access the Website or use
                any services. If these terms and conditions are considered an
                offer by the I2OC, acceptance is expressly limited to these
                terms.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >The Website is available only to individuals who are at least
                16 years old. If you are not yet 16 years old, you must stop
                using the Website immediately or else provide I2OC with written
                parental approval.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Our basic products and services are free to both Website owners
                &amp; individual users. However we may offer some paid upgrades
                for advanced features such as monthly subscription charges or
                yearly subscription charges.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Our products and services are designed to give users as much
                control and ownership over their content as possible. However,
                employer must be responsible for the content they posted during
                job post and also recruiters when applying to the job on behalf
                of applicant as well.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              &nbsp;
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: Arial;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >SPECIAL LICENSE RESTRICTIONS FOR NON-HUMAN VISITORS</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >A special restriction on a visitor's license to access the
                Website applies to all Non-Human Visitors. Non-Human Visitors
                include, but are not limited to, web spiders, bots, indexers,
                robots, crawlers, harvesters, or any other computer programs
                designed to access, read, compile or gather content from the
                Website automatically.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Email addresses on the I2OC are considered proprietary
                intellectual property. It is recognized that these email
                addresses are provided for human visitors alone. You acknowledge
                and agree that each email address the Website contains has a
                value not less than US $50. You further agree that the
                compilation, storage, and/or distribution of these addresses
                substantially diminishes the value of these addresses.
                Intentional collection, harvesting, gathering, and/or storing
                the Website's email addresses is recognized as a violation of
                this agreement and expressly prohibited.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: Arial;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Ownership</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >You do not claim intellectual property right or exclusive
                ownership to any of our products or services, whether modified
                or unmodified. All products and services are the property of
                I2OC. Our products and services are provided 'as is' without
                warranty of any kind, either expressed or implied. In no event
                shall our organization (or any business or individual associated
                with I2OC) be liable for any damages including, but not limited
                to, direct, indirect, special, punitive, incidental or
                consequential, or other losses arising out of the use of or
                inability to use our products or services.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: Arial;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Your I2OC Account.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >If you create an account with I2OC, you are responsible for
                maintaining the security of your account, and you are fully
                responsible for all activities that occur under the account and
                any other actions taken in connection with the account. You must
                not describe or assign keywords to your content while posting
                the job or while applying to the job post &nbsp;in a misleading
                or unlawful manner, including in a manner intended to trade on
                the name or reputation of others, and I2OC may change or remove
                any description or keyword that it considers inappropriate or
                unlawful, or otherwise likely to cause I2OC to be positioned for
                possible liability. You must immediately notify I2OC of any
                unauthorized uses of your account, your account or any other
                breaches of security. I2OC will not be liable for any acts or
                omissions by you, including any damages of any kind incurred as
                a result of such acts or omissions.</span
              >
            </p>
            <ul style="margin-top: 0pt; margin-bottom: 0pt;">
              <li
                dir="ltr"
                style='list-style-type:disc;font-size:10pt;font-family:"Noto Sans Symbols"color:#162532;background-color:transparent;vertical-align:baseline'
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 6.1pt;
                    margin-bottom: 6.1pt;
                  "
                >
                  <span
                    style="
                      font-size: 11pt;
                      font-family: Arial;
                      background-color: transparent;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >no obligation to provide a refund of any amounts previously
                    paid.</span
                  >
                </p>
              </li>
            </ul>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Fees and Payment.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Optional premium paid services (such as monthly or yearly fees,
                etc.) by selecting a premium service you agree to pay I2OC the
                monthly or annual subscription fees indicated for that service.
                Payments will be charged on the day you sign up for a premium
                service and will cover the use of that service for a monthly or
                annual period as indicated. Premium service fees are not
                refundable.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Responsibility of Application Users.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >I2OC has not reviewed, and cannot review, all of the material
                posted to the Website, and cannot therefore be responsible for
                that material's content, use or effects. By operating the
                Website, I2OC does not represent or imply that it endorses the
                material there posted, or that it believes such material to be
                accurate, useful or non-harmful. You are responsible for taking
                precautions as necessary to protect yourself and your computer
                systems from viruses, worms, Trojan horses, and other harmful or
                destructive content. Any user or site owner who finds content
                that is offensive, indecent, or otherwise objectionable, or
                content containing technical inaccuracies, typographical
                mistakes, or other errors has a responsibility to report such
                Content to I2OC. In the same way, anyone who discovers Content
                on the Website that contains material that violates the privacy
                or publicity rights, or infringes the intellectual property and
                other proprietary rights, of third parties, or the downloading,
                copying or use of which is subject to additional terms and
                conditions, stated or unstated, must report the same to I2OC.
                I2OC disclaims any responsibility for any harm resulting from
                the use by visitors of the Website, or from any downloading by
                those visitors of content there posted.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Content Posted on Other Websites.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >We have not reviewed, and cannot review, all of the material,
                including computer software, made available through the Websites
                and WebPages to which I2OC links, and that link to I2OC. I2OC
                does not have any control over those non-I2OC Websites and
                WebPages, and is not responsible for their contents or their
                use. By linking to a non-I2OC Website or webpage, I2OC does not
                represent or imply that it endorses such Website or webpage. You
                are responsible for taking precautions as necessary to protect
                yourself and your computer systems from viruses, worms, Trojan
                horses, and other harmful or destructive content. I2OC disclaims
                any responsibility for any harm resulting from your use of
                non-I2OC Websites and WebPages.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              &nbsp;
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              &nbsp;
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Copyright Infringement and DMCA Policy.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >As I2OC asks others to respect its intellectual property
                rights, it respects the intellectual property rights of others.
                If you believe that material located on or linked to by I2OC
                violates your copyright, you are encouraged to notify I2OC. I2OC
                will respond to all such notices, including as required or
                appropriate by removing the infringing material or disabling all
                links to the infringing material. In the case of a visitor who
                may infringe or repeatedly infringes the copyrights or other
                intellectual property rights of I2OC or others, I2OC may, in its
                discretion, terminate or deny access to and use of the Website.
                In the case of such termination, I2OC will have no obligation to
                provide a refund of any amounts previously paid to I2OC.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Intellectual Property.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >This Agreement does not transfer from I2OC to you any I2OC or
                third party intellectual property, and all right, title and
                interest in and to such property will remain (as between the
                parties) solely with I2OC. I2OC, the I2OC domain, the I2OC logo,
                and all other trademarks, service marks, graphics and logos used
                in connection with I2OC, or the Website are trademarks or
                registered trademarks of I2OC or I2OC's licensors. Other
                trademarks, service marks, graphics and logos used in connection
                with the Website may be the trademarks of other third parties.
                Your use of the Website grants you no right or license to
                reproduce or otherwise use any I2OC or third-party
                trademarks.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Changes.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >I2OC reserves the right, at its sole discretion, to modify or
                replace any part of this Agreement. It is your responsibility to
                check this Agreement periodically for changes. Your continued
                use of or access to the Website following the posting of any
                changes to this Agreement constitutes acceptance of those
                changes. I2OC may also, in the future, offer new services and/or
                features through the Website (including, the release of new
                tools, services and resources). Such new features and/or
                services shall be subject to the terms and conditions of this
                Agreement.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Termination.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >I2OC may terminate your access to all or any part of the
                Website at any time, with or without cause, with or without
                notice, effective immediately. If you wish to terminate this
                Agreement or your I2OC account (if you have one), you may simply
                discontinue using the Website. Notwithstanding the foregoing, if
                you have a VIP, Premium or other Paid Services account, such
                account can only be terminated by I2OC if you materially breach
                this Agreement and fail to cure such breach within thirty (30)
                days from I2OC's notice to you thereof; provided that, I2OC can
                terminate the Website immediately as part of a general shut down
                of our service or other lawful reason. Additionally, a paid
                account may be temporarily terminated pending a determination of
                the facts relating to a possible breach of this Agreement. Upon
                termination, all provisions of this Agreement which by their
                nature should survive termination shall survive termination,
                including, without limitation, ownership provisions, warranty
                disclaimers, indemnity and limitations of liability.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Disclaimer of Warranties.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >The materials on I2OC's Website are provided 'as is'. I2OC
                makes no warranties, expressed or implied, and hereby disclaims
                and negates all other warranties, including without limitation,
                implied warranties or conditions of merchantability, fitness for
                a particular purpose, or non-infringement of intellectual
                property or other violation of rights. Further, I2OC does not
                warrant or make any representations concerning the accuracy,
                likely results, or reliability of the use of the materials on
                its Internet Website or otherwise relating to such materials or
                on any sites linked to this site.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Limitation of Liability.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >In no event will I2OC, or its suppliers or licensors, or any
                individuals associated with those entities, be liable with
                respect to any subject matter of this agreement under any
                contract, negligence, strict liability or other legal or
                equitable theory for: (i) any special, incidental or
                consequential damages; (ii) the cost of procurement or
                substitute products or services; (iii) for interruption of use
                or loss or corruption of data; or (iv) for any amounts that
                exceed the fees paid by you to I2OC under this agreement during
                the twelve (12) month period prior to the cause of action. I2OC
                shall have no liability for any failure or delay due to matters
                beyond their reasonable control. The foregoing shall not apply
                to the extent prohibited by applicable law.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >General Representation and Warranty.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >You represent and warrant that (i) your use of the Website will
                be in strict accordance with the I2OC Privacy Policy, with this
                Agreement and with all applicable laws and regulations
                (including without limitation any local laws or regulations in
                your country, state, city, or other governmental area, regarding
                online conduct and acceptable content, and including all
                applicable laws regarding the transmission of technical data
                exported from the country in which you reside) and (ii) your use
                of the Website will not infringe or misappropriate the
                intellectual property rights of any third party.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >APPLICABLE LAW AND JURISDICTION</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Each party agrees that any suit, action or proceeding brought
                by such party against the other in connection with or arising
                from the Terms of Service ("Judicial Action") shall be governed
                by the law of the state of residence of the registered
                Administrative Contact (the "Admin State") for the Website as
                such laws are applied to agreements between Admin State
                residents entered into and performed entirely within the Admin
                State. You consent to the jurisdiction of federal and state
                courts within the Admin State. You consent to the venue in any
                action brought against him in connection with breaches of these
                Terms of Service. You consent to electronic service of process
                regarding actions under the above agreement.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >RECORDS OF VISITOR USE AND ABUSE</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >You consent to having your Internet Protocol address recorded.
                An email address may appear immediately below (the "Identifier")
                if we suspect potential abuse. The Identifier is uniquely
                matched to your Internet Protocol address. Visitors agree not to
                use this address for any reason.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >VISITORS AGREE THAT HARVESTING, GATHERING, STORING,
                TRANSFERRING TO A THIRD PARTY OR SENDING ANY MESSAGE(S) TO THE
                IDENTIFIER CONSTITUTES AN ACCEPTANCE AND SUBSEQUENT BREACH OF
                THESE TERMS OF SERVICE.</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.2;
                margin-top: 7.9pt;
                margin-bottom: 2.35pt;
                margin-left: 36pt;
              "
            >
              <span
                style="
                  font-size: 14.5pt;
                  font-family: inherit;
                  color: #162532;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >Site Terms of Use Modifications</span
              >
            </p>
            <p
              dir="ltr"
              style="
                line-height: 1.295;
                margin-top: 0;
                margin-bottom: 7.9pt;
                margin-left: 36pt;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 10.5pt;
                  font-family: Arial;
                  color: #333;
                  background-color: transparent;
                  vertical-align: baseline;
                  white-space: pre-wrap;
                "
                >I2OC may revise these Terms of Use for its Website at any time
                without notice. By using this Website you are agreeing to be
                bound by the then current version of these Terms and Conditions
                of Use.</span
              >
            </p>
            <br
          /></span>
        </b-modal>

        <b-modal
          title="Terms & Condition"
          size="lg"
          v-model="termModal"
          @ok="termModal = false"
        >
          <p
            class="MsoNormal"
            style="margin: 0cm 0cm 8pt; line-height: 15.6933px;"
          ></p>
          <h3
            style="
              color: rgb(34, 34, 34);
              font-family: Calibri, sans-serif;
              font-size: 11pt;
              text-align: justify;
            "
          >
            <span
              style="
                font-family: Tahoma;
                color: black;
                background-image: initial;
                background-position: initial;
                background-size: initial;
                background-repeat: initial;
                background-origin: initial;
                background-clip: initial;
              "
              ><b>I2OC’s Privacy Commitment</b></span
            ><span style="font-family: Tahoma;"> </span>
          </h3>
          <div
            style="
              color: black;
              font-family: Roboto;
              font-size: 11pt;
              text-align: justify;
            "
          >
            <span style="font-size: 11pt; font-family: Tahoma;"
              >I2OC has&nbsp;troubled&nbsp;regarding&nbsp;client&nbsp;</span
            ><wbr style="font-size: 11pt;" /><span
              style="font-size: 11pt; font-family: Tahoma;"
              >and user privacy&nbsp;for nearly&nbsp;twenty&nbsp;years, long
              before it became&nbsp;trendy,&nbsp;correctness,
              or&nbsp;wrongfully&nbsp;binding&nbsp;to require&nbsp;such&nbsp;a
              foothold.&nbsp;we tend to&nbsp;raise&nbsp;solely&nbsp;the smallest
              {amount} amount&nbsp;of knowledge&nbsp;necessary,
              gathering&nbsp;solely&nbsp;what&nbsp;we tend
              to&nbsp;believe&nbsp;is crucial&nbsp;for doing business, or
              for&nbsp;the precise&nbsp;dealing at hand.&nbsp;we tend
              to&nbsp;let customers&nbsp;apprehend&nbsp;the
              data&nbsp;we've&nbsp;on them&nbsp;and permit&nbsp;them
              to&nbsp;prefer&nbsp;of specific engagements. But, by far, our
              biggest commitment is that&nbsp;we tend
              to&nbsp;don't&nbsp;create&nbsp;one&nbsp;dollar&nbsp;</span
            ><wbr style="font-size: 11pt;" /><span
              style="font-size: 11pt; font-family: Tahoma;"
              >from advertising revenue—never have,&nbsp;ne'er&nbsp;will—even
              from the free editions of our&nbsp;product.&nbsp;this
              implies&nbsp;we tend to&nbsp;avoid&nbsp;the basic&nbsp;conflict of
              interest between
              gathering&nbsp;client&nbsp;info&nbsp;and&nbsp;</span
            ><wbr style="font-size: 11pt;" /><span
              style="font-size: 11pt; font-family: Tahoma;"
              >refueling&nbsp;advertising revenue,&nbsp;and therefore
              the&nbsp;inevitable&nbsp;compromises in&nbsp;client&nbsp;privacy
              that it brings.</span
            >
          </div>
          <div style="text-align: justify;">
            <font color="#000000" face="Roboto"
              ><span style="font-size: 14.6667px;"><br /></span
            ></font>
          </div>
          <span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >The goal of this policy is&nbsp;to form&nbsp;specific&nbsp;the
                data&nbsp;we tend to&nbsp;gather on our customers and
                users,&nbsp;however&nbsp;we are going to&nbsp;use it,&nbsp;and
                the way&nbsp;we are going to&nbsp;not. This policy
                is&nbsp;sadly&nbsp;longer than&nbsp;we
                might&nbsp;like,&nbsp;however&nbsp;we tend
                to&nbsp;should&nbsp;unambiguously address all the relevant
                cases.&nbsp;we are going to&nbsp;attempt to&nbsp;keep the
                language&nbsp;easy&nbsp;and direct&nbsp;the maximum
                amount&nbsp;as&nbsp;attainable.</span
              >
            </div></span
          >
          <div style="text-align: justify;"><br /></div>
          <span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >Purposes for&nbsp;mistreatment&nbsp;info</span
              >
            </div></span
          ><span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >In addition to&nbsp;the needs&nbsp;mentioned&nbsp;higher
                than,&nbsp;we tend to&nbsp;might&nbsp;use
                your&nbsp;info&nbsp;for&nbsp;the subsequent&nbsp;purposes:</span
              >
            </div></span
          >
          <div style="text-align: justify;"><br /></div>
          <span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To communicate with you (such as through
                email)&nbsp;regarding&nbsp;product&nbsp;that you
                simply&nbsp;have downloaded and services&nbsp;that you
                simply&nbsp;have signed up for, changes&nbsp;to the
                current&nbsp;Privacy Policy, changes to the Terms of Service,
                or&nbsp;necessary&nbsp;notices;</span
              >
            </div></span
          ><span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To keep you&nbsp;denote&nbsp;on new&nbsp;product&nbsp;and
                services,&nbsp;future&nbsp;events, offers, promotions
                and&nbsp;alternative&nbsp;info&nbsp;that&nbsp;we
                expect&nbsp;are&nbsp;of interest to you;</span
              >
            </div></span
          ><span
            style="
              color: black;
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To&nbsp;raise&nbsp;you to participate in surveys, or to solicit
                feedback on our&nbsp;product&nbsp;and services;</span
              >
            </div></span
          ><span
            style="
              color: black;
              font-family: Roboto;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt; font-family: Tahoma;"
                >To set up and maintain your account, and&nbsp;to try and
                do&nbsp;all&nbsp;alternative&nbsp;things&nbsp;</span
              ><wbr style="font-size: 11pt;" /><span
                style="font-size: 11pt; font-family: Tahoma;"
                >needed&nbsp;for providing our services,&nbsp;reminiscent
                of&nbsp;sanctionative&nbsp;</span
              ><wbr style="font-size: 11pt;" /><span
                style="font-size: 11pt; font-family: Tahoma;"
                >collaboration, providing&nbsp;web &nbsp;mail hosting, and
                backing up and restoring your data</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To understand&nbsp;however&nbsp;users use
                our&nbsp;product&nbsp;and services,&nbsp;to watch&nbsp;and
                forestall&nbsp;issues, and&nbsp;to
                boost&nbsp;our&nbsp;product&nbsp;and services;</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To provide&nbsp;client&nbsp;support, and&nbsp;to
                investigate&nbsp;and improve our interactions with
                customers;</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Calibri, sans-serif;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt; font-family: Tahoma;"
                >To&nbsp;sight&nbsp;and forestall&nbsp;deceitful&nbsp;</span
              ><wbr style="font-size: 11pt;" /><span
                style="font-size: 11pt; font-family: Tahoma;"
                >transactions and&nbsp;alternative&nbsp;ill-gotten&nbsp;</span
              ><wbr style="font-size: 11pt;" /><span
                style="font-size: 11pt; font-family: Tahoma;"
                >activities, to report spam, and&nbsp;to shield&nbsp;the rights
                and interests of I2OC, I2OC’s users, third parties&nbsp;and
                therefore the&nbsp;public;</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To update, expand and analyze our
                records,&nbsp;establish&nbsp;new customers,&nbsp;and
                supply&nbsp;product&nbsp;and services&nbsp;that will&nbsp;be of
                interest to you;</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To analyze trends, administer our websites, and
                track&nbsp;traveller&nbsp;navigations on our websites&nbsp;to
                know&nbsp;what&nbsp;guests&nbsp;square measure&nbsp;searching
                for&nbsp;and&nbsp;to higher&nbsp;facilitate&nbsp;them;</span
              >
            </div></span
          ><span
            style="
              color: rgb(34, 34, 34);
              font-family: Tahoma;
              font-size: 11pt;
              background-image: initial;
              background-position: initial;
              background-size: initial;
              background-repeat: initial;
              background-origin: initial;
              background-clip: initial;
            "
            ><div style="text-align: justify;">
              <span style="font-size: 11pt;"
                >To monitor and improve&nbsp;promoting&nbsp;campaigns
                and&nbsp;create&nbsp;suggestions relevant to the user.</span
              >
            </div></span
          >
          <p></p>
          <p
            class="MsoNormal"
            style="
              text-align: justify;
              margin: 0cm 0cm 8pt;
              color: rgb(34, 34, 34);
              line-height: 15.6933px;
              font-size: 11pt;
              font-family: Calibri, sans-serif;
            "
          >
            <span
              style="
                font-family: Roboto;
                color: black;
                background-image: initial;
                background-position: initial;
                background-size: initial;
                background-repeat: initial;
                background-origin: initial;
                background-clip: initial;
              "
              ><span style="font-family: Tahoma;"
                >For any query related to our privacy and policy kindly mail us
                at</span
              ><span style="font-family: Tahoma;">&nbsp;</span
              ><a
                href="mailto:info@i2oc.com"
                target="_blank"
                style="color: rgb(17, 85, 204);"
                ><span style="font-family: Tahoma;">info@i2oc.com</span></a
              ></span
            >
          </p>
        </b-modal>
        <b-modal
          title="Select Plan"
          no-close-on-esc
          no-close-on-backdrop
          size="lg"
          hide-footer
          class="modal-warning"
          v-model="planModal"
          @ok="planModal = true"
          ok-variant="warning"
        >
          <b-collapse id="collapse3" visible>
            <table style="width: 100%;" v-if="plan_dt !== null">
              <tr>
                <th></th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="free"
                    name="selplan"
                    checked
                    v-bind:value="plan_dt[0].plan_type"
                  />&nbsp;{{ plan_dt[0].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="basic"
                    name="selplan"
                    v-bind:value="plan_dt[1].plan_type"
                  />&nbsp;{{ plan_dt[1].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="standard"
                    name="selplan"
                    v-bind:value="plan_dt[2].plan_type"
                  />&nbsp;{{ plan_dt[2].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="professional"
                    name="selplan"
                    v-bind:value="plan_dt[3].plan_type"
                  />&nbsp;{{ plan_dt[3].plan_label}}
                </th>
              </tr>
              <tr>
                <td></td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[0].cost
                  }}</span>
                </td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[1].cost
                  }}</span>
                </td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[2].cost
                  }}</span>
                </td>
                <td>
                  <i class="fa fa-inr" aria-hidden="true" style="color: rgb(221, 120, 89); font-size: 30px;"></i>
                  <span style="color: rgb(221, 120, 89); font-size: 32px;">{{plan_dt[3].cost}}</span>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
              </tr>
               <tr>
                <td style="font-weight: bold;">Warehouse / Shop</td>
                <td v-if="plan_dt[0].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].shop_count }}</td>
                <td v-if="plan_dt[1].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].shop_count }}</td>
                <td v-if="plan_dt[2].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].shop_count }}</td>
                <td v-if="plan_dt[3].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].shop_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Users Allowed</td>
                <td v-if="plan_dt[0].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].user_count }}</td>
                <td v-if="plan_dt[1].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].user_count }}</td>
                <td v-if="plan_dt[2].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].user_count }}</td>
                <td v-if="plan_dt[3].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].user_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Third Party Ecommerce Integration</td>
                <td>
                  <i
                    v-if="plan_dt[0].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <!-- <tr>
                <td style="font-weight: bold;">Invoice</td>
                <td v-if="plan_dt[0].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].inv_count }}</td>
                <td v-if="plan_dt[1].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].inv_count }}</td>
                <td v-if="plan_dt[2].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].inv_count }}</td>
                <td v-if="plan_dt[3].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].inv_count }}</td>
              </tr> -->
               <tr>
                <td style="font-weight: bold;">Invoices</td>
                <td>
                  <i
                    v-if="plan_dt[0].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Reports</td>
                <td>
                  <i
                    v-if="plan_dt[0].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">GST Reports</td>
                <td>
                  <i
                    v-if="plan_dt[0].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <!-- <tr>
                <td style="font-weight: bold;">Balance Payment</td>
                <td>
                  <i
                    v-if="plan_dt[0].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr> -->

              <tr>
                <td style="font-weight: bold;">Max no. of Categories Allowed</td>
                <td v-if="plan_dt[0].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].cat_count }}</td>
                <td v-if="plan_dt[1].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].cat_count }}</td>
                <td v-if="plan_dt[2].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].cat_count }}</td>
                <td v-if="plan_dt[3].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].cat_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max no. of Products Allowed</td>
                <td v-if="plan_dt[0].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].prod_count }}</td>
                <td v-if="plan_dt[1].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].prod_count }}</td>
                <td v-if="plan_dt[2].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].prod_count }}</td>
                <td v-if="plan_dt[3].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].prod_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Sales</td>
                <td>
                  <i
                    v-if="plan_dt[0].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Purchase</td>
                <td>
                  <i
                    v-if="plan_dt[0].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Customers</td>
                <td v-if="plan_dt[0].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].cust_count }}</td>
                <td v-if="plan_dt[1].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].cust_count }}</td>
                <td v-if="plan_dt[2].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].cust_count }}</td>
                <td v-if="plan_dt[3].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].cust_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Suppliers</td>
                <td v-if="plan_dt[0].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].supp_count }}</td>
                <td v-if="plan_dt[1].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].supp_count }}</td>
                <td v-if="plan_dt[2].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].supp_count }}</td>
                <td v-if="plan_dt[3].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].supp_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Barcodes</td>
                <td>
                  <i
                    v-if="plan_dt[0].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Desktop Application</td>
                <td>
                  <i
                    v-if="plan_dt[0].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td colspan="5" style="text-align: center;">
                  <button
                    class="btn btn-lg btn-primary btn-pill"
                    type="button"
                    @click="plan_select"
                  >
                    Submit
                  </button>
                </td>
              </tr>
              
            </table>
          </b-collapse>
        </b-modal>
        <Spinner v-if="loading"></Spinner>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      logo:null,
      bg_img:null,
      planModal: false,
      selplan: "0",
      plan_dt: null,
      plan_dt_save: {},
      termModal: false,
      privacyModal: false,
      loading: false,
      cityopt: [],
      city: null,
      registerData: {
        username: "",
        companyname: "",
        email: "",
        phone: "",
        password: "",
        confirmpassword: "",
        agree: false,
        plan: "Free",
        selplan: 0,
      },
      hasErrors: {
        message: false,
        username: false,
        companyname: false,
        email: false,
        phone: false,
        password: false,
        agree: false,
        plan: false,
      },
      messagepassword: "",
      errorMessage: {
        message: null,
        username: null,
        companyname: null,
        email: null,
        phone: null,
        password: null,
        agree: null,
        plan: null,
      },
      // refPlan: { 0: "Free", 1: "Basic", 2: "Standard", 3: "Professional" },
    };
  },
  created() {
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    Promise.all([this.plan()]).then((ret_val) => {
      this.plan_dt = this.plan_dt_save;
      this.city1();
    });
  },
  methods: {
    plan_select() {
      this.planModal = false;
      // this.registerData.plan = this.refPlan[parseInt(this.selplan)];
      this.registerData.plan = this.plan_dt[parseInt(this.selplan)]['plan_label']
      this.registerData.selplan = this.selplan;
    },
    async plan() {
      var _this = this;
      this.plan_dt_save = {};
      this.$http
        .get("/api/plans")
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            _this.plan_dt_save[response.data[i]["plan_type"]] = response.data[i];
            if (i === response.data.length - 1) {
              if(_this.$route.query.type !== undefined && _this.$route.query.type !== null){
                _this.registerData.plan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_label']
                _this.registerData.selplan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_type']
                _this.selplan = _this.$route.query.type.toString()
              }
              return Promise.resolve(true);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    showplan() {
      this.planModal = true;
    },
    city1() {
      this.cityopt = [];
      this.city = null;
      var _this = this;

      this.$http
        .get("/api/dbconnects")
        .then(function (response) {
          _this.cityopt = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    registerPost() {
      var submit_true = 0;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;

      _this.hasErrors.phone = false;
      _this.hasErrors.companyname = false;
      _this.hasErrors.username = false;
      _this.hasErrors.email = false;
      _this.hasErrors.agree = false;

      if (this.registerData.password === this.registerData.confirmpassword) {
        vm.password = false;
        if (this.city === null) {
          alert("please Select DataCenter Location");
          submit_true = 1;
        }

        var regex = /^[a-zA-Z0-9\s]{3,100}$/;
        var uregex = /^[a-zA-Z\s]{3,100}$/;
        var prex = /^[0-9]{10,15}$/;
        var eregex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

        if (
          this.registerData.password != this.registerData.confirmpassword ||
          this.registerData.password == ""
        ) {
          _this.hasErrors.password = true;
          _this.errorMessage.password =
            "Password & ConfirmPassword Does Not Match";
          submit_true = 1;
        }

        if (prex.test(this.registerData.phone) == false) {
          _this.hasErrors.phone = true;
          (_this.errorMessage.phone = "Phone is required in correct Format"),
            (submit_true = 1);
        }

        if (regex.test(this.registerData.companyname) == false) {
          _this.hasErrors.companyname = true;
          (_this.errorMessage.companyname =
            "CompanyName is required in correct Format"),
            (submit_true = 1);
        }

        if (regex.test(this.registerData.username) == false) {
          _this.hasErrors.username = true;
          (_this.errorMessage.username =
            "UserName is required in correct Format"),
            (submit_true = 1);
        }

        // let email_temp = this.registerData.email;
        this.registerData.email = this.registerData.email.toLowerCase();
        if (eregex.test(this.registerData.email) == false) {
          _this.hasErrors.email = true;
          (_this.errorMessage.email = "Email is required in correct Format"),
            (submit_true = 1);
        }

        if (pass.test(this.registerData.password) == false) {
          vm.password = true;
          _this.messagepassword =
            "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
          submit_true = 1;
        }

        if (this.registerData.agree == false) {
          vm.agree = true;
          _this.errorMessage.agree = "Required";
          submit_true = 1;
        }

        if (submit_true == 0) {
          let res = {
            phone: this.registerData.phone,
            companyname: this.registerData.companyname,
            username: this.registerData.username,
            email: this.registerData.email,
            password: this.registerData.password,
            txt_pass: this.registerData.password,
            regcity_code: this.city.shortname,
            plan_type: this.registerData.selplan
          };

          this.loading = true;
          this.$http
            .post("/api/users", res)
            .then(function (response) {
              if (response.status === 200) {
                _this.loading = false;
                _this.hasErrors.message = true;
                _this.$router.push("/afterregister");
                // _this.errorMessage.message="Confirmation Email Has Been Sent. Please Verify Your Email To Activate Your Account";
                _this.registerData.username = "";
                _this.registerData.companyname = "";
                _this.registerData.email = "";
                _this.registerData.phone = "";
                _this.registerData.password = "";
                _this.registerData.confirmpassword = "";
                _this.registerData.agree = false;
                _this.registerData.plan = "";
                _this.registerData.selplan = 0;
                _this.city = null;
                document.getElementById("username").required = false;
                document.getElementById("companyname").required = false;
                document.getElementById("email").required = false;
                document.getElementById("phone").required = false;
                document.getElementById("password").required = false;
                document.getElementById("confirmpassword").required = false;
              } else {
                // console.log('unknown');
              }
            })

            .catch(function (error) {
              //  console.log(error)
              _this.loading = false;
              //error.response.data.error.details.messages.email[0]
              //console.log(error.response.data.error.details.messages.email);
              var errors = error.response;
              console.log(errors);
              if (errors.statusText === "Unprocessable Entity") {
                if (errors.data) {
                  if (error.response.data.error.details.messages.username) {
                    vm.username = true;
                    _vm.username =
                      error.response.data.error.details.messages.username[0];
                  }
                  if (error.response.data.error.details.messages.companyname) {
                    vm.companyname = true;
                    _vm.companyname =
                      error.response.data.error.details.messages.companyname[0];
                  }
                  if (error.response.data.error.details.messages.email) {
                    vm.email = true;
                    _vm.email =
                      error.response.data.error.details.messages.email[0];
                  }
                  if (error.response.data.error.details.messages.phone) {
                    vm.phone = true;
                    _vm.phone =
                      error.response.data.error.details.messages.phone[0];
                  }
                  if (error.response.data.error.details.messages.password) {
                    vm.password = true;
                    _vm.password =
                      error.response.data.error.details.messages.password[0];
                  }
                }
              } else if (errors.statusText === "unknown") {
                if (errors.status === 455) {
                  alert(
                    "Email is already registeredwith us. You have deactivated your account. Kindly contact to Administrator to Activate your account again."
                  );
                }
              }
            });
        }
      } else {
        vm.password = true;
        _this.messagepassword = "Password & ConfirmPassword Does Not Match";
        // console.log('if check');
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/Register.vue